// 페이지별 SEO 메타데이터 (다국어).
// 키워드 전략은 docs/seo-keywords.md 참고.
// 추가 페이지가 생기면 여기에 entry 추가 → SEO 컴포넌트가 자동 적용.
//
// [시트 동기화 2026-06-24] 클라이언트 확정본("VIP Van Tour SEO 개발자 맞춤형 시트.xlsx",
//   URL SEO 관리 탭) 반영. title/description/h1/ogImage/ogImageAlt = 시트 원문.
//   - h1: 페이지 본문 대표 제목(타이틀과 별개). SEO 컴포넌트가 sr-only h1 + og:title 로 사용.
//   - ogImage: 페이지별 OG 이미지(/images/og/*.webp, 1200x630). 실제 webp 자산은 별도 업로드.
//   - keywords 는 기존 SEO 전략 유지.

const SITE_NAME = 'VIP Van Tour';

export const PAGE_META = {
  "/": {
    ko: {
      title: "인천공항·김포공항 프라이빗 픽업 & 서울 투어 | VIP Van Tour",
      description: "서울 호텔과 인천공항·김포공항을 연결하는 프라이빗 밴 이동 및 맞춤 투어 서비스입니다. 공항 이동, 비즈니스 의전, DMZ, 남이섬, 골프, 쇼핑, 병원 방문 등 다양한 프라이빗 이동 및 투어 서비스를 제공합니다.",
      h1: "서울 공항 픽업 · 인천공항 픽업 · 프라이빗 투어",
      ogImage: "/images/og/social/vip-van-tour-seoul-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour premium van providing private airport transfers and tours in Seoul, Korea",
    },
    en: {
      title: "Private Airport Transfers & Tours in Seoul, Korea | VIP Van Tour",
      description: "Private van service connecting Seoul hotels with Incheon and Gimpo airports. Enjoy safe and comfortable airport transfers, business travel, DMZ tours, Nami Island tours, golf transfers, shopping services, and customized private tours across Korea.",
      h1: "Private Airport Transfers & Tours in Seoul, Korea",
      ogImage: "/images/og/social/vip-van-tour-seoul-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour premium van providing private airport transfers and tours in Seoul, Korea",
    },
    ja: {
      title: "ソウル市内ホテル ↔ 仁川空港・金浦空港の貸切送迎サービス | VIP Van Tour",
      description: "ソウル市内のホテルと仁川空港・金浦空港を結ぶ貸切送迎サービスです。空港送迎、ビジネス送迎、DMZツアー、南怡島観光、ゴルフ送迎などを安全かつ快適にご案内します。",
      h1: "ソウルの貸切送迎・空港送迎・プライベートツアー",
      ogImage: "/images/og/social/vip-van-tour-seoul-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour premium van providing private airport transfers and tours in Seoul, Korea",
    },
    zh: {
      title: "首尔酒店 ↔ 仁川机场、金浦机场私人接送服务 | VIP Van Tour",
      description: "提供首尔酒店与仁川机场、金浦机场之间的私人接送及包车旅游服务。涵盖机场接送、商务出行、DMZ、南怡岛、高尔夫及定制旅游，安全舒适。",
      h1: "首尔私人接送 · 机场接送 · 定制旅游",
      ogImage: "/images/og/social/vip-van-tour-seoul-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour premium van providing private airport transfers and tours in Seoul, Korea",
    },
    es: {
      title: "Traslados Privados al Aeropuerto y Tours en Seúl | VIP Van Tour",
      description: "Servicio privado de transporte entre hoteles de Seúl y los aeropuertos de Incheon y Gimpo. Disfrute de traslados cómodos y seguros para viajes de negocios, tours privados, DMZ, Isla Nami, golf y compras en Corea.",
      h1: "Traslados Privados al Aeropuerto y Tours en Seúl, Corea",
      ogImage: "/images/og/social/vip-van-tour-seoul-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour premium van providing private airport transfers and tours in Seoul, Korea",
    },
  },

  "/transfer/airport": {
    ko: {
      title: "인천공항·김포공항 프라이빗 픽업 & 샌딩 | VIP Van Tour",
      description: "서울과 인천공항·김포공항을 연결하는 프라이빗 공항 이동 서비스입니다. 전문 드라이버와 프리미엄 밴으로 공항 픽업 및 샌딩을 안전하고 편안하게 제공합니다.",
      h1: "서울 ↔ 인천공항·김포공항 프라이빗 공항 픽업 & 샌딩 서비스",
      ogImage: "/images/og/social/seoul-incheon-airport-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private airport transfer at Incheon Airport with professional driver and travelers",
      keywords: ["공항이동", "인천공항 콜밴", "김포공항 콜밴", "공항 픽업", "공항 샌딩", "의전차량"],
    },
    en: {
      title: "Seoul Airport Transfer to/from Incheon & Gimpo Airport | VIP Van Tour",
      description: "Enjoy private airport transfers between Seoul, Incheon Airport, and Gimpo Airport with hotel pickup. Travel comfortably in a premium van with professional drivers and door-to-door service.",
      h1: "Private Airport Transfer between Seoul, Incheon & Gimpo Airport",
      ogImage: "/images/og/social/seoul-incheon-airport-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private airport transfer at Incheon Airport with professional driver and travelers",
      keywords: ["Seoul airport transfer", "Incheon airport pickup", "Gimpo airport van", "private van Seoul", "ICN to Seoul transfer", "VIP taxi Seoul"],
    },
    ja: {
      title: "ソウル 空港送迎サービス｜仁川空港・金浦空港 プライベート送迎 | VIP Van Tour",
      description: "仁川空港・金浦空港とソウル市内を結ぶプライベート空港送迎サービス。プロドライバー付きのプレミアムバンで、安全・快適なドアツードア移動をご提供します。",
      h1: "ソウル 空港送迎サービス（仁川空港・金浦空港）",
      ogImage: "/images/og/social/seoul-incheon-airport-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private airport transfer at Incheon Airport with professional driver and travelers",
      keywords: ["ソウル 空港送迎", "仁川空港 送迎", "金浦空港 送迎", "ソウル プライベート送迎", "韓国 空港 ピックアップ"],
    },
    zh: {
      title: "韩国首尔机场接送服务｜仁川机场·金浦机场包车 | VIP Van Tour",
      description: "提供首尔市区与仁川机场、金浦机场之间的私人接送机服务。专业司机驾驶舒适商务车，为您提供安全便捷的门到门出行体验。",
      h1: "首尔机场接送服务（仁川机场·金浦机场）",
      ogImage: "/images/og/social/seoul-incheon-airport-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private airport transfer at Incheon Airport with professional driver and travelers",
      keywords: ["首尔机场接送", "仁川机场接送", "金浦机场接送", "首尔私人包车", "韩国机场接机", "首尔机场专车"],
    },
    es: {
      title: "Traslado Privado entre Seúl y los Aeropuertos de Incheon y Gimpo | VIP Van Tour",
      description: "Servicio privado de traslado entre Seúl y los aeropuertos de Incheon y Gimpo. Disfrute de un viaje cómodo y seguro con conductor profesional y una van premium.",
      h1: "Traslado Privado entre Seúl y los Aeropuertos de Incheon y Gimpo",
      ogImage: "/images/og/social/seoul-incheon-airport-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private airport transfer at Incheon Airport with professional driver and travelers",
      keywords: ["traslado aeropuerto Incheon", "transporte aeropuerto Seúl", "van privada Corea", "taxi VIP Seúl"],
    },
  },

  "/transfer/golf": {
    ko: {
      title: "서울 출발 골프장 프라이빗 이동 | 골프 픽업 & 샌딩 | VIP Van Tour",
      description: "서울에서 전국 주요 골프장까지 이동하는 프라이빗 골프 이동 서비스입니다. 골프백 적재가 가능한 프리미엄 밴과 전문 드라이버가 편안하고 안전한 골프장 픽업 및 샌딩 서비스를 제공합니다.",
      h1: "서울 출발 프라이빗 골프장 이동 서비스",
      ogImage: "/images/og/social/private-golf-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour private golf transfer with golf carts and a golf course in Korea",
      keywords: ["골프이동", "골프장 콜밴", "골프 의전", "골프백 운반", "경기 골프장 이동", "강원 골프장 이동"],
    },
    en: {
      title: "Private Golf Transfer from Seoul | Golf Transportation in Korea | VIP Van Tour",
      description: "Enjoy private golf transportation from Seoul to Korea's top golf courses. Travel comfortably in premium vans with spacious storage for golf bags and professional drivers for a seamless golf transfer experience.",
      h1: "Private Golf Transfer from Seoul",
      ogImage: "/images/og/social/private-golf-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour private golf transfer with golf carts and a golf course in Korea",
      keywords: ["Korea golf transfer", "Seoul golf van", "golf course shuttle Korea", "private van golf Korea"],
    },
    ja: {
      title: "韓国ゴルフ場プライベート送迎 | ソウル発 | VIP Van Tour",
      description: "ソウルから韓国各地のゴルフ場へ向かうプライベート送迎サービスです。ゴルフバッグも余裕で積載できるプレミアムバンとプロドライバーが、快適で安全なゴルフ移動を提供します。",
      h1: "韓国ゴルフ場プライベート送迎サービス",
      ogImage: "/images/og/social/private-golf-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour private golf transfer with golf carts and a golf course in Korea",
      keywords: ["韓国 ゴルフ 送迎", "ソウル ゴルフ場 送迎", "ゴルフ プライベートバン 韓国"],
    },
    zh: {
      title: "韩国高尔夫球场私人接送服务 | 首尔出发 | VIP Van Tour",
      description: "提供首尔往返韩国各大高尔夫球场的私人接送服务。配备宽敞舒适的商务车，可轻松容纳高尔夫球包，并由专业司机提供安全便捷的出行体验。",
      h1: "韩国高尔夫球场私人接送服务",
      ogImage: "/images/og/social/private-golf-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour private golf transfer with golf carts and a golf course in Korea",
      keywords: ["韩国高尔夫接送", "首尔高尔夫包车", "京畿高尔夫球场接送", "韩国golf包车"],
    },
    es: {
      title: "Traslado Privado a Campos de Golf en Corea | Desde Seúl | VIP Van Tour",
      description: "Servicio privado de transporte desde Seúl a los principales campos de golf de Corea. Viaje cómodamente en vans premium con amplio espacio para bolsas de golf y conductores profesionales.",
      h1: "Traslado Privado para Golf desde Seúl",
      ogImage: "/images/og/social/private-golf-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour private golf transfer with golf carts and a golf course in Korea",
      keywords: ["traslado golf Corea", "van campo golf Seúl"],
    },
  },

  "/transfer/resort": {
    ko: {
      title: "서울 출발 스키장·워터파크 프라이빗 이동 | VIP Van Tour",
      description: "서울 호텔 또는 지정 장소에서 출발하여 비발디파크, 용평리조트, 오션월드, 캐리비안베이 등 전국 주요 스키장 및 워터파크까지 편안하게 이동하는 프라이빗 차량 서비스입니다. 스키 장비와 여행 짐도 넉넉하게 적재 가능한 프리미엄 밴으로 안전하고 편리한 이동을 경험하세요.",
      h1: "서울 출발 스키장·워터파크 프라이빗 이동 서비스",
      ogImage: "/images/og/social/seoul-private-waterpark-transfer-og.webp",
      ogImageAlt: "VIP Van Tour resort transfer with family travelers at a water park in Korea",
      keywords: ["스키장 이동", "스키 콜밴", "용평 이동", "하이원 이동", "강원 스키장 의전", "스키 단체이동"],
    },
    en: {
      title: "Private Ski & Water Park Transfer from Seoul | VIP Van Tour",
      description: "Enjoy private transfers from Seoul hotels to Korea's top ski resorts and water parks, including Vivaldi Park, Yongpyong Resort, Ocean World, and Caribbean Bay. Travel comfortably in premium vans with ample space for ski equipment and luggage.",
      h1: "Private Ski & Water Park Transfer from Seoul",
      ogImage: "/images/og/social/seoul-private-waterpark-transfer-og.webp",
      ogImageAlt: "VIP Van Tour resort transfer with family travelers at a water park in Korea",
      keywords: ["Korea ski transfer", "Yongpyong shuttle", "High1 ski van", "Pyeongchang ski transfer"],
    },
    ja: {
      title: "韓国スキー場・ウォーターパーク送迎サービス | ソウル発プライベート送迎 | VIP Van Tour",
      description: "ソウルのホテルからビバルディパーク、龍平リゾート、オーシャンワールド、カリビアンベイなど韓国主要スキー場やウォーターパークへのプライベート送迎サービスです。スキー用品や旅行荷物も余裕で積載できるプレミアムバンで快適に移動できます。",
      h1: "ソウル発スキー場・ウォーターパーク送迎サービス",
      ogImage: "/images/og/social/seoul-private-waterpark-transfer-og.webp",
      ogImageAlt: "VIP Van Tour resort transfer with family travelers at a water park in Korea",
      keywords: ["韓国 スキー 送迎", "龍平 送迎", "ハイワン 送迎", "平昌 スキー 送迎"],
    },
    zh: {
      title: "韩国滑雪场・水上乐园私人接送服务 | 首尔出发包车 | VIP Van Tour",
      description: "提供首尔往返韩国主要滑雪场及水上乐园的私人接送服务，包括维瓦尔第公园、龙平度假村、海洋世界及加勒比海湾等。配备宽敞商务车，可轻松容纳滑雪装备与行李，出行更加舒适便捷。",
      h1: "首尔出发滑雪场及水上乐园私人接送服务",
      ogImage: "/images/og/social/seoul-private-waterpark-transfer-og.webp",
      ogImageAlt: "VIP Van Tour resort transfer with family travelers at a water park in Korea",
      keywords: ["韩国滑雪接送", "龙平滑雪接送", "韩国滑雪场包车", "平昌滑雪接送"],
    },
    es: {
      title: "Traslado Privado desde Seúl a Estaciones de Esquí y Parques Acuáticos | VIP Van Tour",
      description: "Servicio privado de transporte desde hoteles en Seúl a las principales estaciones de esquí y parques acuáticos de Corea, como Vivaldi Park, Yongpyong Resort, Ocean World y Caribbean Bay. Viaje cómodamente en vans premium con amplio espacio para equipaje y equipo deportivo.",
      h1: "Traslado Privado a Estaciones de Esquí y Parques Acuáticos desde Seúl",
      ogImage: "/images/og/social/seoul-private-waterpark-transfer-og.webp",
      ogImageAlt: "VIP Van Tour resort transfer with family travelers at a water park in Korea",
      keywords: ["traslado esquí Corea", "van Yongpyong", "transporte estación esquí Seúl"],
    },
  },

  "/transfer/hospital": {
    ko: {
      title: "서울 병원 프라이빗 이동 | 입·퇴원 지원 서비스 | VIP Van Tour",
      description: "서울 전 지역 병원 및 클리닉 프라이빗 이동 서비스입니다. 입원·퇴원 이동, 병원 방문 동행, 수하물 운반 및 접이식 휠체어 이용 고객 이동을 지원합니다. 해외 환자와 동반 가족을 위한 안전하고 편안한 프리미엄 밴 서비스입니다.",
      h1: "서울 병원·클리닉 프라이빗 이동 및 입·퇴원 지원",
      ogImage: "/images/og/social/seoul-private-hospital-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private hospital transfer with admission and discharge assistance at a medical center in Seoul",
      keywords: ["병원 이동", "의전 콜밴", "병원 픽업", "환자 이동", "검진 콜밴"],
    },
    en: {
      title: "Private Hospital Transfer in Seoul | Admission & Discharge Support | VIP Van Tour",
      description: "Private hospital and clinic transfer service across Seoul with admission and discharge support. Includes non-medical escort assistance, luggage handling, and transportation support for passengers using foldable wheelchairs. Designed to provide safe and comfortable transportation for international patients and their families.",
      h1: "Private Hospital Transfer in Seoul for Medical Tourists",
      ogImage: "/images/og/social/seoul-private-hospital-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private hospital transfer with admission and discharge assistance at a medical center in Seoul",
      keywords: ["Seoul medical transport", "hospital van Korea", "patient transfer Seoul", "medical tourism transport Korea"],
    },
    ja: {
      title: "ソウルの病院・クリニック プライベート送迎 | 入退院サポート付き | VIP Van Tour",
      description: "ソウル全域の病院・クリニックへのプライベート送迎サービスです。入院・退院時の移動サポートに加え、付き添いサポート、荷物運搬、折りたたみ式車椅子をご利用のお客様の移動支援にも対応しています。海外からの医療観光客やご家族も安心してご利用いただけます。",
      h1: "ソウルの病院・クリニック プライベート送迎・入退院サポート",
      ogImage: "/images/og/social/seoul-private-hospital-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private hospital transfer with admission and discharge assistance at a medical center in Seoul",
      keywords: ["韓国 病院 送迎", "ソウル 医療観光 送迎", "韓国 美容整形 送迎"],
    },
    zh: {
      title: "首尔医院·诊所私人接送服务 | 入院·出院支持 | VIP Van Tour",
      description: "提供首尔全区域医院及诊所的私人接送服务，支持入院与出院交通安排。包含陪同协助、行李搬运及折叠轮椅使用客户的出行支持，为国际患者及其家属提供安全、舒适、便捷的高端接送服务。",
      h1: "首尔医院及诊所私人接送与入院·出院支持服务",
      ogImage: "/images/og/social/seoul-private-hospital-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private hospital transfer with admission and discharge assistance at a medical center in Seoul",
      keywords: ["首尔医院接送", "韩国医疗观光接送", "韩国医美包车", "首尔体检接送"],
    },
    es: {
      title: "Traslado Privado a Hospitales en Seúl | Ingreso y Alta Médica | VIP Van Tour",
      description: "Servicio privado de traslado a hospitales y clínicas en toda Seúl con soporte para ingreso y alta médica. Incluye asistencia de acompañamiento no médico, manejo de equipaje y apoyo para usuarios de sillas de ruedas plegables, ofreciendo un transporte seguro, cómodo y confiable para pacientes internacionales y sus familias.",
      h1: "Traslado Privado a Hospitales y Clínicas en Seúl",
      ogImage: "/images/og/social/seoul-private-hospital-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private hospital transfer with admission and discharge assistance at a medical center in Seoul",
      keywords: ["transporte médico Seúl", "turismo médico Corea van"],
    },
  },

  "/transfer/pet": {
    ko: {
      title: "반려동물 동반 프라이빗 이동 | 공항·동물병원·장거리 이동 | VIP Van Tour",
      description: "사랑하는 반려동물과 함께 편안하게 이동하는 프라이빗 차량 서비스입니다. 대형 켄넬과 캐리어 적재가 가능하며 공항 이동, 동물병원 방문, 장거리 여행까지 안전하고 쾌적한 반려동물 이동 서비스를 제공합니다.",
      h1: "반려동물 동반 프라이빗 이동 서비스",
      ogImage: "/images/og/social/pet-friendly-private-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour pet-friendly transfer with a dog owner and pet carrier in Korea",
      keywords: ["반려동물 이동", "펫 콜밴", "강아지 콜밴", "펫택시", "반려견 공항이동"],
    },
    en: {
      title: "Pet-Friendly Private Transfer in Korea | Airport, Vet & Long-Distance Travel | VIP Van Tour",
      description: "Travel comfortably with your pets across Korea using our premium private transfer service. Ideal for airport transfers, veterinary visits, and long-distance travel. Our spacious vehicles accommodate pet carriers and large kennels for a safe and stress-free journey.",
      h1: "Pet-Friendly Transportation & Private Transfer in Korea",
      ogImage: "/images/og/social/pet-friendly-private-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour pet-friendly transfer with a dog owner and pet carrier in Korea",
      keywords: ["Korea pet transport", "pet friendly taxi Seoul", "travel with pet Korea"],
    },
    ja: {
      title: "韓国 ペット同伴プライベート送迎 | 空港・動物病院・長距離移動 | VIP Van Tour",
      description: "大切なペットと一緒に快適に移動できるプライベート送迎サービスです。大型ケージやキャリーケースにも対応し、空港送迎、動物病院への通院、長距離移動まで安心・安全にサポートします。",
      h1: "韓国 ペット同伴プライベート送迎",
      ogImage: "/images/og/social/pet-friendly-private-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour pet-friendly transfer with a dog owner and pet carrier in Korea",
      keywords: ["韓国 ペット 送迎", "ペット同伴 タクシー ソウル"],
    },
    zh: {
      title: "韩国宠物友好私人包车服务 | 机场接送・宠物医院・长途出行 | VIP Van Tour",
      description: "提供韩国宠物友好私人包车服务，可携带宠物航空箱及大型宠物笼，适用于机场接送、宠物医院就诊及长途旅行，为您与爱宠提供安全、舒适、无压力的出行体验。",
      h1: "韩国宠物友好私人包车服务",
      ogImage: "/images/og/social/pet-friendly-private-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour pet-friendly transfer with a dog owner and pet carrier in Korea",
      keywords: ["韩国宠物包车", "首尔宠物接送", "宠物出租车 首尔"],
    },
    es: {
      title: "Transporte Privado para Mascotas en Corea | Aeropuerto, Veterinario y Viajes Largos | VIP Van Tour",
      description: "Servicio privado para mascotas en Corea. Viaje con su mascota de forma segura y cómoda al aeropuerto, clínicas veterinarias o destinos de larga distancia. Vehículos con amplio espacio para transportadoras y jaulas.",
      h1: "Servicio de Transporte Privado para Mascotas en Corea",
      ogImage: "/images/og/social/pet-friendly-private-transfer-korea-og.webp",
      ogImageAlt: "VIP Van Tour pet-friendly transfer with a dog owner and pet carrier in Korea",
      keywords: ["traslado mascotas Corea", "taxi mascotas Seúl"],
    },
  },

  "/transfer/business": {
    ko: {
      title: "기업 의전 및 비즈니스 이동 서비스 | 공항 픽업·출장·MICE | VIP Van Tour",
      description: "기업 고객 및 해외 바이어를 위한 프리미엄 비즈니스 의전 및 프라이빗 이동 서비스입니다. 인천공항·김포공항 픽업 및 샌딩, 비즈니스 미팅, 출장, MICE 행사 이동까지 지원하며 영어 가능 기사와 프리미엄 밴으로 안전하고 품격 있는 이동 경험을 제공합니다.",
      h1: "기업 의전 및 비즈니스 이동 서비스",
      ogImage: "/images/og/social/business-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private business transfer with international travelers arriving at a corporate meeting venue",
      keywords: ["비즈니스 의전", "바이어 의전", "출장 콜밴", "의전 차량 임대", "기업 의전"],
    },
    en: {
      title: "Corporate Chauffeur & Executive Transfer in Korea | Airport Transfer · Business · MICE | VIP Van Tour",
      description: "Premium corporate chauffeur and executive transfer service in Korea for business travelers and international clients. Enjoy private airport transfers to and from Incheon and Gimpo airports, business meetings, corporate travel, and MICE events with professional English-speaking drivers, ensuring punctuality, privacy, and comfort.",
      h1: "Corporate Chauffeur & VIP Executive Transfer Service in Korea",
      ogImage: "/images/og/social/business-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private business transfer with international travelers arriving at a corporate meeting venue",
      keywords: ["Seoul business transport", "executive van Korea", "business chauffeur Seoul", "corporate transport Korea"],
    },
    ja: {
      title: "韓国 ビジネス送迎・企業専用車サービス | 空港・出張・MICE対応 | VIP Van Tour",
      description: "韓国での出張や企業訪問、VIP送迎に対応したプレミアムビジネス送迎サービスです。仁川空港・金浦空港送迎、商談、MICEイベントなどに対応し、時間厳守とプライバシーを重視した快適で上質な移動サービスをご提供します。",
      h1: "韓国 ビジネス送迎・企業専用車サービス",
      ogImage: "/images/og/social/business-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private business transfer with international travelers arriving at a corporate meeting venue",
      keywords: ["韓国 出張 送迎", "ソウル ビジネス 送迎", "バイヤー 送迎 韓国"],
    },
    zh: {
      title: "韩国商务接送与企业包车服务 | 机场接送·会议·MICE | VIP Van Tour",
      description: "为企业客户及海外商务人士提供高端商务接送服务，涵盖仁川机场、金浦机场接送、商务会议、企业出行及MICE活动。专业司机与高级商务车全程服务，确保准时、私密与舒适的出行体验。",
      h1: "韩国商务接送与企业包车服务",
      ogImage: "/images/og/social/business-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private business transfer with international travelers arriving at a corporate meeting venue",
      keywords: ["韩国商务包车", "首尔商务用车", "韩国出差接送", "客户接待用车"],
    },
    es: {
      title: "Servicio de Transporte Ejecutivo en Corea | Aeropuerto, Negocios y MICE | VIP Van Tour",
      description: "Servicio premium de transporte ejecutivo y corporativo en Corea para viajeros de negocios y empresas internacionales. Incluye traslados privados desde y hacia los aeropuertos de Incheon y Gimpo, reuniones de negocios, viajes corporativos y eventos MICE con chófer profesional y vehículos premium, garantizando puntualidad, privacidad y comodidad.",
      h1: "Servicio Privado de Transporte Ejecutivo en Corea",
      ogImage: "/images/og/social/business-private-transfer-og.webp",
      ogImageAlt: "VIP Van Tour private business transfer with international travelers arriving at a corporate meeting venue",
      keywords: ["transporte ejecutivo Seúl", "van negocios Corea"],
    },
  },

  "/tour": {
    ko: {
      title: "서울 프라이빗 투어 | 호텔 픽업 맞춤 여행 | VIP Van Tour",
      description: "서울 호텔 픽업으로 진행되는 프라이빗 투어 서비스입니다. 경복궁, 북촌, 남산 등 서울 주요 명소를 가족 및 소규모 그룹만을 위한 맞춤 일정으로 편안하고 안전하게 여행하세요.",
      h1: "서울 프라이빗 투어 | 호텔 픽업 맞춤 여행",
      ogImage: "/images/og/social/seoul-private-tour-hotel-pickup-vip-van-tour-og.webp",
      ogImageAlt: "VIP Van Tour premium van with travelers enjoying a private tour in Seoul, Korea",
      keywords: ["프라이빗 투어", "서울 투어", "가족 여행 패키지", "서울 근교 투어", "맞춤 여행"],
    },
    en: {
      title: "Private Seoul Tour with Hotel Pickup | Private Tour in Korea | VIP Van Tour",
      description: "Explore Seoul with a private tour including hotel pickup and premium van transportation. Enjoy flexible itineraries designed for families and small groups with professional drivers.",
      h1: "Private Seoul Tour with Hotel Pickup",
      ogImage: "/images/og/social/seoul-private-tour-hotel-pickup-vip-van-tour-og.webp",
      ogImageAlt: "VIP Van Tour premium van with travelers enjoying a private tour in Seoul, Korea",
      keywords: ["private Seoul tour", "Korea private tour", "custom Seoul itinerary", "Seoul day tour", "private van tour Korea"],
    },
    ja: {
      title: "韓国・ソウル プライベートツアー | ホテル送迎付き貸切観光 | VIP Van Tour",
      description: "ソウル市内ホテル送迎付きのプライベートツアー。家族や少人数グループ向けに、快適な貸切車両で自由な観光をお楽しみください。",
      h1: "ソウル プライベートツアー｜ホテル送迎付き",
      ogImage: "/images/og/social/seoul-private-tour-hotel-pickup-vip-van-tour-og.webp",
      ogImageAlt: "VIP Van Tour premium van with travelers enjoying a private tour in Seoul, Korea",
      keywords: ["ソウル プライベートツアー", "韓国 個人ツアー", "ソウル 観光 専用車", "カスタム 韓国旅行"],
    },
    zh: {
      title: "韩国首尔私人定制旅游 | 酒店接送包车自由行 | VIP Van Tour",
      description: "提供首尔酒店接送的私人定制旅游和高端包车服务，适合家庭及小团体自由行，享受舒适便捷的专属出行体验。",
      h1: "首尔私人定制旅游（酒店接送）",
      ogImage: "/images/og/social/seoul-private-tour-hotel-pickup-vip-van-tour-og.webp",
      ogImageAlt: "VIP Van Tour premium van with travelers enjoying a private tour in Seoul, Korea",
      keywords: ["首尔私人游", "韩国包车游", "首尔定制游", "首尔一日游 包车"],
    },
    es: {
      title: "Tour Privado en Seúl con Recogida en el Hotel | Tour Personalizado en Corea | VIP Van Tour",
      description: "Disfruta de un tour privado personalizado en Seúl con servicio cómodo de recogida en el hotel y van premium para familias y grupos pequeños. Reserva ahora.",
      h1: "Tour Privado en Seúl con Recogida en el Hotel",
      ogImage: "/images/og/social/seoul-private-tour-hotel-pickup-vip-van-tour-og.webp",
      ogImageAlt: "VIP Van Tour premium van with travelers enjoying a private tour in Seoul, Korea",
      keywords: ["tour privado Seúl", "tour Corea español", "itinerario personalizado Seúl"],
    },
  },

  "/shopping": {
    ko: {
      title: "한국 상품 사전 주문 & 공항 픽업 서비스 | VIP Van Tour",
      description: "올리브영, 다이소, 마트 인기 상품을 미리 주문하고 서울 호텔 또는 인천공항·김포공항 이동 당일 차량에서 편하게 받아보세요. 쇼핑과 공항 이동을 한 번에 해결하는 프라이빗 서비스입니다.",
      h1: "한국 상품 사전 주문 & 공항 픽업 서비스",
      ogImage: "/images/og/social/korea-private-shopping-airport-delivery.webp",
      ogImageAlt: "VIP Van Tour airport delivery service with pre-ordered Korean products and private transfer",
    },
    en: {
      title: "Korea Airport Transfer & Pre-Order Shopping Service | VIP Van Tour",
      description: "Pre-order popular Korean products from Olive Young, Daiso, and local marts before your trip and receive them in your private van on your airport transfer day. Enjoy shopping and transportation in one convenient service in Korea.",
      h1: "Korea Airport Transfer & Pre-Order Shopping Service",
      ogImage: "/images/og/social/korea-private-shopping-airport-delivery.webp",
      ogImageAlt: "VIP Van Tour airport delivery service with pre-ordered Korean products and private transfer",
    },
    ja: {
      title: "韓国 空港送迎＋事前注文ショッピング | VIP Van Tour",
      description: "オリーブヤング、ダイソー、マートの人気商品を事前注文し、空港送迎当日に車内で受け取れる便利なサービスです。ショッピングと空港移動を一度にお楽しみいただけます。",
      h1: "韓国 空港送迎＋事前注文ショッピング",
      ogImage: "/images/og/social/korea-private-shopping-airport-delivery.webp",
      ogImageAlt: "VIP Van Tour airport delivery service with pre-ordered Korean products and private transfer",
    },
    zh: {
      title: "韩国机场接送＋预购购物服务 | VIP Van Tour",
      description: "提前预订 Olive Young、大创及超市热门商品，并在机场接送当天于专车内领取。购物与机场接送一次完成，轻松开启韩国之旅。",
      h1: "韩国机场接送＋预购购物服务",
      ogImage: "/images/og/social/korea-private-shopping-airport-delivery.webp",
      ogImageAlt: "VIP Van Tour airport delivery service with pre-ordered Korean products and private transfer",
    },
    es: {
      title: "Servicio de Traslado al Aeropuerto y Compras Anticipadas en Corea | VIP Van Tour",
      description: "Reserva productos populares de Corea antes de tu viaje y recíbelos en tu van privada el día del traslado al aeropuerto. Una forma cómoda y segura de combinar compras y transporte.",
      h1: "Servicio Privado de Compras Anticipadas y Traslado al Aeropuerto en Corea",
      ogImage: "/images/og/social/korea-private-shopping-airport-delivery.webp",
      ogImageAlt: "VIP Van Tour airport delivery service with pre-ordered Korean products and private transfer",
    },
  },

  '/about': {
    ko: { title: '회사 소개 | VIP Van Tour', description: 'VIP Van Tour 회사 소개. 안전하고 신뢰할 수 있는 의전 이동·프라이빗 투어 서비스.' },
    en: { title: 'About Us | VIP Van Tour', description: "About VIP Van Tour - Korea's trusted private van transfer and tour service for international travelers." },
    ja: { title: '会社紹介 | VIP Van Tour', description: 'VIP Van Tour 会社紹介。韓国の信頼できるプライベートバン送迎・ツアーサービス。' },
    zh: { title: '关于我们 | VIP Van Tour', description: 'VIP Van Tour 公司介绍。韩国值得信赖的私人包车接送·旅游服务。' },
    es: { title: 'Sobre Nosotros | VIP Van Tour', description: 'Acerca de VIP Van Tour - Servicio de van privada y tours en Corea para viajeros internacionales.' },
  },

  '/faq': {
    ko: { title: '자주 묻는 질문 (FAQ) | VIP Van Tour', description: '예약, 결제, 차량, 무료 대기 등 자주 묻는 질문 모음.' },
    en: { title: 'FAQ | VIP Van Tour', description: 'Frequently asked questions about booking, payment, vehicles, and waiting time.' },
    ja: { title: 'よくある質問 | VIP Van Tour', description: '予約・支払い・車両・無料待機についてよくある質問。' },
    zh: { title: '常见问题 | VIP Van Tour', description: '关于预订、支付、车辆、免费等待等常见问题。' },
    es: { title: 'Preguntas Frecuentes | VIP Van Tour', description: 'Preguntas frecuentes sobre reservas, pagos, vehículos y tiempo de espera.' },
  },

  '/partnership': {
    ko: { title: '제휴 안내 | VIP Van Tour', description: '여행사·호텔·골프장·기업 제휴 문의.' },
    en: { title: 'Partnership | VIP Van Tour', description: 'Partnership inquiries from travel agencies, hotels, golf clubs, and corporates.' },
    ja: { title: '提携のご案内 | VIP Van Tour', description: '旅行会社・ホテル・ゴルフ場・企業との提携問い合わせ。' },
    zh: { title: '合作洽询 | VIP Van Tour', description: '旅行社·酒店·高尔夫球场·企业合作洽询。' },
    es: { title: 'Alianzas | VIP Van Tour', description: 'Consultas de alianzas con agencias de viajes, hoteles, golf y empresas.' },
  },

  '/reviews': {
    ko: { title: '이용 후기 | VIP Van Tour', description: '실제 이용 고객의 후기 모음.' },
    en: { title: 'Customer Reviews | VIP Van Tour', description: 'Real customer reviews of VIP Van Tour service.' },
    ja: { title: 'お客様の声 | VIP Van Tour', description: '実際にご利用いただいたお客様の声。' },
    zh: { title: '客户评价 | VIP Van Tour', description: '真实客户对VIP Van Tour服务的评价。' },
    es: { title: 'Opiniones | VIP Van Tour', description: 'Opiniones reales de clientes de VIP Van Tour.' },
  },
};

/** 페이지에서 호출: 현재 route key + 언어로 메타 조회.
 *  exact match → 부모 경로 match(/tour/15 → /tour) → '/' fallback */
export function getPageMeta(route, beLang) {
  let entry = PAGE_META[route];
  // 부모 경로 fallback (동적 라우트 대응: /tour/15 → /tour)
  if (!entry && route && route !== '/') {
    const parts = route.split('/').filter(Boolean);
    while (parts.length > 0 && !entry) {
      parts.pop();
      const parent = parts.length ? '/' + parts.join('/') : '/';
      entry = PAGE_META[parent];
    }
  }
  if (!entry) entry = PAGE_META['/'];
  if (!entry) return { title: SITE_NAME, description: '' };
  return entry[beLang] || entry.ko || Object.values(entry)[0] || { title: SITE_NAME, description: '' };
}

export { SITE_NAME };
